import React, {useState} from 'react';
import useMerchantPortalAxios, {useMerchantPortalFormData} from "../utils/axios";
import {setFlag, setIsPopup, setLoading, setResponseDescription, setResponseTitle} from "../features/responseSlice";
import {useDispatch} from "react-redux";
import { setPaymentRequest } from '../features/paymentRequestSlice';

const PaymentRequestAPI = () => {
    const MerchantPortalAxios = useMerchantPortalAxios();
    const MerchantPortalAxios1 = useMerchantPortalFormData();
    const [totalNbOfPage, setTotalNbOfPage] = React.useState(1);
    const [totalCount, setTotalCount] = useState(0);
    // const [paymentRequests, setPaymentRequests] = useState([]);
    const [requestLoading, setRequestsLoading] = useState(true);

    const dispatch = useDispatch();

    const GetPaymentRequest = async (pageNb) => {
        await MerchantPortalAxios.post(
            '/v1/PaymentRequest/GetPaymentRequest',
            {
                SessionID: sessionStorage.getItem("SessionID"),
                page: pageNb,
                pageSize: 10,
            }
        ).then((res) => {
            // setPaymentRequests(res.data.Payload.PaymentRequests);
            dispatch(setPaymentRequest(res.data.Payload.PaymentRequests))
            if (res.data.Payload.PaymentRequests?.length===0){
                setTotalNbOfPage(0);
                setTotalCount(0);
            }else{
                setTotalNbOfPage(res.data.Payload.PaymentRequests[0].TotalPages);
                setTotalCount(res.data.Payload.PaymentRequests[0].TotalCount);
            }

            if (res.data.Payload.TemplateURL)
                sessionStorage.setItem("PaymentRequestTemplate", res.data.Payload.TemplateURL);

            setRequestsLoading(false);

        }).finally(() => dispatch(setLoading("idle")));
        
    }

    const InitiatePaymentRequest = async (payload) => {
        const response = await MerchantPortalAxios.post('/v1/PaymentRequest/InitiatePaymentRequest', payload);
        return response.data;
    }

    const InitiateBulkPaymentRequest = async (payload) => {
        if (payload.formFile) {
            const fileData = payload.formFile.split(',')[1];
            const mimeType = payload.formFile.split(':')[1].split(';')[0];
            const byteCharacters = atob(fileData);
            const byteArrays = new Uint8Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
                byteArrays[i] = byteCharacters.charCodeAt(i);
            }
            const file = new File([byteArrays], payload.ReasonFileName, {type: mimeType});
            payload.formFile = file;
        }
        const {ReasonFileName, ...newPayload} = payload

        const response = await MerchantPortalAxios1.post('/v1/PaymentRequest/InitiateBulkPaymentRequest', newPayload);
        return response.data;

    };

    const RemindPaymentRequest = async (transactionId) => {
        dispatch(setLoading("pending"));
        const response = MerchantPortalAxios.post('/v1/PaymentRequest/RemindPaymentRequest', {
            SessionID: sessionStorage.getItem("SessionID"),
            TransactionID: transactionId
        }).then((res) => {
            const data = res?.data?.Payload;
            dispatch(setLoading("idle"));
            if (data?.isPopup) {
                dispatch(setIsPopup(true));
                dispatch(setFlag(data?.flagCode || 0));
                dispatch(setResponseTitle(data?.Title));
                dispatch(setResponseDescription(data?.Message));
            }
        }).catch((err) => {
            if(err.response?.data?.PopupTitle === "LoaderError"){
                return;
            }else{
                dispatch(setLoading("idle"));
            }
        });

    }

    const ReversePayment = async (payload) => {
        const response = await MerchantPortalAxios.post('/v1/PaymentRequest/ReversePayment', payload);
        return response.data.Payload;
    }

    const CancelRequestToPay = async (payload) => {
        const response = await MerchantPortalAxios.post('/v1/PaymentRequest/CancelRequestToPay', payload);
        return response.data.Payload;
    }


    return {
        GetPaymentRequest,
        requestLoading,
        totalNbOfPage,
        totalCount,
        InitiatePaymentRequest,
        InitiateBulkPaymentRequest,
        RemindPaymentRequest,
        ReversePayment,
        CancelRequestToPay
    };
}

export default PaymentRequestAPI;